<!-- Add Credit -->
<p-drawer [(visible)]="showCreditSidebar" [showCloseIcon]="false" position="right" [blockScroll]="true" [dismissible]="false"
  styleClass="w-full payment-sidebar no-header p-0" [dismissible]="false" appendTo="body" [modal]="true">
  <ng-template #headless>
  <div class="p-sidebar-content__wrapper surface-100">
    <!-- Header -->
    <div class="border-bottom-1 border-300 relative flex align-items-center sticky left-0 top-0 w-full surface-0 z-5">
      <div (click)="closeCreditSidebar()" class="h-3rem w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center">
          <i class="fa fa-times text-xl text-600"></i>
      </div>
      <div class="flex align-items-center ml-3">
          <h4 class="flex align-items-center mb-0 mr-3 text-base font-bold">
              <i class="fa fa-dollar text-600 mr-2"></i>
              <span class="text-sm">
                {{'CREDIT_BALANCE.ADD_CREDIT' | translate}}
              </span>
          </h4>
      </div>
  </div>

    <!-- Header -->

    <!-- Name -->
    <div class="surface-0 flex px-3 py-2 align-items-center justify-content-between">
      <div class="flex align-items-center">
        <p-skeleton *ngIf="showSkeleton | async" width="2rem" height="2rem" shape="circle"></p-skeleton>
        <div class="h-2rem w-2rem" *ngIf="(showSkeleton | async) === false">
          <p-avatar *ngIf="clientData.image; else noContactPic" [image]="clientData.image"
            shape="circle"></p-avatar>
          <ng-template #noContactPic>
            <p-avatar [label]="clientData.full_name | titlecase | shortName" shape="circle"></p-avatar>
          </ng-template>
        </div>
        <p-skeleton *ngIf="showSkeleton | async" width="7rem" height="1.35rem" styleClass="mx-2"></p-skeleton>
        <div>
        <h3 class="mb-0 ml-2 md:-mt-1" *ngIf="(showSkeleton | async) === false">
          <a href="../client/profile/{{ clientData.id }}"
            class="text-primary text-base mr-2 font-bold border-bottom-1 border-white hover:border-primary">
            {{ clientData.full_name }}
          </a>
          <span class="text-600 font-normal text-sm">{{'common.DATA.CLIENT_ID' | translate}} - {{clientData.id}}</span>
        </h3>
        <div class="text-xs text-600 mb-0 w-9 white-space-nowrap text-overflow-ellipsis flex align-items-center ml-2 mt-1" *ngIf="billingNameFormControl.value"><strong>
              {{ 'POS.MEMBERSHIP_ADDON.BILLING_NAME' | translate }} :
            </strong> {{ billingNameFormControl.value }}
            <span class="fa fa-times text-xl text-600 cursor-pointer ml-2 text-xs" (click)="removeBillingName()">
            </span>
          </div>
        </div>
      </div>

      <div class="flex align-items-center justify-content-end">
        <p-skeleton *ngIf="showSkeleton | async" width="4rem" height="1.35rem" styleClass="mr-1"></p-skeleton>
        <div *ngIf="(showSkeleton | async) === false" [innerHTML]="clientStatus(clientData)"></div>

        <p-skeleton *ngIf="showSkeleton | async" width="2rem" height="2rem"></p-skeleton>
        <button pButton pRipple type="button" icon="fa fa-ellipsis-h" *ngIf="(showSkeleton | async) === false"
          class="surface-0 p-button-outlined border-300 ml-2 md:ml-3 text-xs md:text-sm p-1 md:p-2 h-2rem w-2rem text-600"
          (click)="action.toggle($event)"></button>
        <p-popover #action styleClass="overflow-hidden right-0 text-sm w-10rem -ml-3">
          <ng-template #content>
            <!-- <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
              <li class="cursor-pointer hover:surface-300 p-3 flex align-items-center"
                (click)="changeBillOwnerModal=true"><i class="fa fa-user-edit text-xs mr-2"></i>Edit Billing Name</li>
            </ul> -->
            <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
              <li class="cursor-pointer hover:surface-300 p-3 flex align-items-center" (click)="changeBillingName=true">
                <i class="fa fa-user-edit text-xs mr-2"></i>
                {{'POS.MEMBERSHIP_ADDON.EDIT_BILLING_NAME' | translate}}
              </li>
            </ul>
          </ng-template>
        </p-popover>
      </div>

    </div>
    <!-- Name -->

    <!-- Mid Part -->
    <div class="py-3 border-top-1 border-300">
      <form [formGroup]="creditBalanceForm">
        <!-- Bill Owner and Date -->
        <div class="flex justify-content-between flex-wrap px-3">
          <div class="w-6">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CREDIT_BALANCE.BILL_DATE' | translate}}</label>
            <p-skeleton *ngIf="showSkeleton | async" width="100%" height="2rem"></p-skeleton>
            <p-datepicker *ngIf="(showSkeleton | async) === false" [showIcon]="true" formControlName="payment_date" [readonlyInput]="true"
              placeholder="{{'common.PLACEHOLDER.SELECT_DATE' | translate}}" inputStyleClass="text-sm"
              styleClass="" [minDate]="disableDatesUpTo">
            </p-datepicker>
          </div>
          <div class="w-6">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'CREDIT_BALANCE.BILL_OWNER' | translate}}</label>
            <p-skeleton *ngIf="showSkeleton | async" width="14rem" height="2.15rem"></p-skeleton>
            <staff-selector *ngIf="(showSkeleton | async) === false" [formGroup]="creditBalanceForm" [controlName]="billingOwner" [styleClass]="'w-14rem text-sm'"
              [placeHolder]="'CreateEditStaff.SELECT_PLACEHOLDER' | translate" [filterstaff]="_filterStaff" [id]="_selectedstaff">
            </staff-selector>
            <app-error-msg *ngIf="billingOwner.dirty && billingOwner.invalid" [errors]="billingOwner.errors"
              [fieldLabel]="'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate">
            </app-error-msg>
          </div>
         
        </div>
        <!-- Bill Owner and Date -->

      
      <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3">

      <!-- Grand Total -->
      <div class="px-3">
        <div
          class="border-1 border-300 border-round px-3 py-2 flex align-items-center justify-content-between surface-0 text-sm">
          <span>{{'CREDIT_BALANCE.CREDIT_AMOUNT' | translate}}</span>
          <div>
          <p-skeleton *ngIf="showSkeleton | async" width="14rem" height="2.15rem"></p-skeleton>
          <div *ngIf="(showSkeleton | async) === false" class="p-inputgroup w-8rem">
            <span class="p-inputgroup-addon"> {{currencySymbol$ | async}}</span>
            <!-- <p-inputNumber [format]="false" styleClass="wpx-0 text-sm" formControlName="credit_amount" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5"></p-inputNumber>
             -->
             <app-input-number [formGroup]="creditBalanceForm" [controlName]="CreditBalanceFormControl" [styleClass]="'wpx-0 text-sm'" [conditionToFormat]="true"></app-input-number>
          </div>
          <app-error-msg *ngIf="CreditBalanceFormControl.dirty && CreditBalanceFormControl.invalid"
          [errors]="CreditBalanceFormControl.errors" [fieldLabel]="'CREDIT_BALANCE.CREDIT_AMOUNT' | translate">
        </app-error-msg>
          <!-- <p class="p-error mb-0 text-sm mt-1">Error Msg</p> -->
        </div>
        </div>
        <div
          class="px-3 py-2 flex align-items-center justify-content-between surface-900 text-white border-round-bottom">
          <span>{{'CREDIT_BALANCE.GRAND_AMOUNT' | translate}}</span>
          <p-skeleton *ngIf="showSkeleton | async" width="14rem" height="2rem"></p-skeleton>
          <span *ngIf="(showSkeleton | async) === false" class="text-right">{{ creditBalance | currencyformat }}
          </span>
        </div>
      </div>
      <!-- Grand Total -->
    </form>
    </div>
    <!-- Mid Part -->

  </div>

  <!-- Bottom Part -->
  <div class="sticky bottom-0 right-0 w-full p-3 surface-400">
    <div class="relative mx-auto text-center">
      <p-button styleClass="w-full justify-content-center align-items-center p-0" (click)="showPaymentModule()" [loading]="isSubmitting">
        <div class="flex align-items-center mr-3 p-3 w-full">
          <strong class="p-button-label ml-2">{{'PAYMENT.OFFLINE_CONTINUE' | translate}}</strong>
        </div>
      </p-button>
    </div>
  </div>
  <!-- Bottom Part -->
  </ng-template>
</p-drawer>
<!-- Add Credit Sidebar -->

<div *ngIf="showCreditSidebar" class="p-component-overlay p-sidebar-mask p-component-overlay-enter z-100"></div>


<!-- Change Billing Name Modal  -->
<p-dialog [(visible)]="changeBillingName" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <form [formGroup]="billingNameForm">
      <!-- Header -->
      <div class="p-3 flex align-items-center justify-content-between relative border-bottom-1 border-300">
        <h2 class="mb-0 text-sm"> {{'POS.MEMBERSHIP_ADDON.CHANGE_BILLING_NAME' | translate}}</h2>
        <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="changeBillingName = false"></div>
      </div>
      <!-- Header -->


      <!-- Modal Content -->
      <div class="surface-100 border-bottom-1 border-300 p-3">

        <!-- Column -->
        <label class="font-medium text-700 text-xs mb-2 block uppercase"> {{'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME'
          | translate}}</label>
        <input type="text" class="text-sm w-full" formControlName="billing_name" pInputText
          placeholder="Enter the new billing name" />
        <app-error-msg *ngIf="billingNameFormControl.dirty && billingNameFormControl.invalid"
          [errors]="billingNameFormControl.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate">
        </app-error-msg>
        <!-- Column -->

      </div>
      <!-- Modal Content -->


      <!-- Modal Footer -->
      <div class="surface-0 border-top-1 border-300 p-3">
        <p-button [disabled]="billingNameFormControl.invalid" styleClass="w-full"
          label="{{'POS.MEMBERSHIP_ADDON.NEW_BILLING_NAME' | translate}}" (click)="changeBillingName=false"></p-button>
      </div>
      <!-- Modal Footer -->

    </form>

  </ng-template>

</p-dialog>
<!-- Change Billing Name Modal  -->

<other-payment *ngIf="otherPaymentsModal$ | async" [otherPaymentsModal]="otherPaymentsModal$ | async" [showCreditBalanceForClientCredit]="true"
  [totalAmtTobePaid]="creditBalance" [showCreditBalance]="false" (hideOtherPaymentDialog)="HideOtherPaymentDialog($event)">
</other-payment>

<app-errors *ngIf="showErrorPopup | async as showPopup" [error]="error" [visible]="showPopup"
  [errorData]="errorMessages" (hideErrorPopup)="HideErrorPopup($event)">
</app-errors>